// Renders a product name, breaking a trailing size or parenthetical onto its own line.
export const renderProductName = (name) => {
  const size = name.match(/^(.*?)(\s+\d+"\s*x\s*\d+")$/);
  if (size) {
    return (
      <>
        {size[1]}
        <br />
        {size[2].trim()}
      </>
    );
  }
  const paren = name.match(/^(.*?)\s+(\(.*\))\s*$/);
  if (paren) {
    return (
      <>
        {paren[1]}
        <br />
        {paren[2]}
      </>
    );
  }
  return name;
};
